<div class="__header-line" *ngIf="profile" [class.--is-desktop]="isDesktop">
  <mip-avatar [size]="isMobile ? 100 : 150" [userModel]="profile" [borderWidth]="3" borderColor="gray--darker"></mip-avatar>

  <div class="__info">
    <h2 class="__name">
      <span *ngIf="profile.name">
        {{ profile.name }}
      </span>
      <mip-profile-slug-name *ngIf="!profile.name" [user]="profile" badgeSize="5x"></mip-profile-slug-name>

      <!-- PROFILE-ACTIONS -->
      <div class="__actions" *ngIf="isDesktop">
        <mip-profile-user-actions [profile]="profile" *ngIf="profile.isAuthenticated"></mip-profile-user-actions>

        <mip-profile-public-actions [profile]="profile" *ngIf="!profile.isAuthenticated"></mip-profile-public-actions>
      </div>
    </h2>

    <div class="__bio" *ngIf="profile.bio">
      <span *ngIf="expandBio">{{ profile.bio }}</span>
      <span *ngIf="!expandBio">{{ profile.bio | slice : 0 : totalCharacters }}{{ profile.bio.length > totalCharacters ? '...' : '' }}</span>

      <a class="__see-more" *ngIf="profile.bio.length > totalCharacters" (click)="expandBio = !expandBio">
        <span mipTranslate="see-more" *ngIf="!expandBio">more</span>
        <span mipTranslate="see-less" *ngIf="expandBio">less</span>
      </a>
    </div>

    <div class="__url" *ngIf="profile.profileUrl">
      <mip-icon icon="url" size="3x"></mip-icon>
      <a [href]="profile.profileUrl" target="_blank">
        {{ profile.profileUrl }}
      </a>
    </div>
  </div>
</div>
